<template>
  <div class="order-meal-card">
    <div class="meal-img-container">
      <v-img
        v-if="transaction.food.image?.name"
        class="meal-img"
        :aspect-ratio="16 / 9"
        :src="imgSrc(transaction.food.image.name)"
        style="background-color: #b7b7b7"
      />
      <div v-else class="meal-img-placeholder" style="aspect-ratio: 16 / 9">
        <v-icon dark size="64" color="#fff">mdi-food</v-icon>
      </div>
    </div>
    <div class="meal-title">
      <span
        :class="settings.font.uppercase && 'text-uppercase'"
        :style="{ fontSize: foodFontSize }"
      >
        {{ toLatin(transaction.food.name) }}
      </span>
      <div v-if="transaction.food.translation">
        <v-divider class="my-1"></v-divider>
        {{ transaction.food.translation }}
      </div>
    </div>
    <div v-if="transaction.quantity > 1" class="quantity-badge" :style="item.state === 'success' ? 'background: #08b360;': 'background: #b71c1c'">
      x{{ transaction.quantity }}
    </div>
  </div>
</template>

<script>
import conf from "@/config";
export default {
  props: {
    transaction: {
      type: Object,
      required: true,
    },
    settings: {
      type: Object,
      default: () => ({}),
    },
    item: {
      type: Object,
      default: "",
    },
  },
  computed: {
    foodImgSize() {
      return this.settings?.image?.size || 64;
    },
    foodFontSize() {
      return this.settings?.font?.size?.food + "px";
    },
  },
  methods: {
    imgSrc(name) {
      return (
        conf.apiUrlBase +
        "/gallery/" +
        this.$store.state.company.restaurant.id +
        "/medium/" +
        name
      );
    },
  },
};
</script>

<style scoped>
.order-meal-card {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(243, 115, 56, 0.12);
  overflow: hidden;
  position: relative;
}
.meal-img-container {
  width: 100%;
  overflow: hidden;
}
.meal-img {
  width: 100%;
  border-radius: 0;
  object-fit: cover;
}
.meal-img-placeholder {
  width: 100%;
  background-color: #b7b7b7;
  display: flex;
  align-items: center;
  justify-content: center;
}
.meal-title {
  padding: 16px 24px;
  font-family: "Poppins", Tahoma, sans-serif;
  font-weight: 700;
  color: #555;
  font-size: 1.1rem;
  line-height: 1.3;
  word-break: break-word;
  text-align: center;
}
.quantity-badge {
  position: absolute;
  right: 12px;
  top: 12px;
  color: #fff;
  font-weight: 700;
  font-size: 2rem;
  letter-spacing: 2px;
  border-radius: 50px;
  min-width: 76px;
  height: 76px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(243, 115, 56, 0.18);
  z-index: 2;
  border: 3px solid #fff;
}
</style>
